import React from "react";
import styled, { keyframes } from "styled-components";

// 定义骨架屏动画
const skeletonAnimation = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// 修改 SkeletonWrapper 样式
const SkeletonWrapper = styled.div`
  position: fixed;
  top: 0; // 顶部对齐
  left: 0; // 左侧对齐
  width: 100%; // 宽度撑满视口
  height: 100vh; // 高度撑满视口
  z-index: 100;
  background: #ffffff;
  border-top: 1px solid rgba(234, 234, 234, 1);
  padding: 15px;
  display: flex; // 使用 flexbox 布局
  flex-direction: column; // 子元素从上往下排列
  box-sizing: border-box;
`;

const SkeletonInput = styled.div`
  width: 100%;
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${skeletonAnimation} 1.5s infinite;
  margin-top: 10px;
  border-radius: 5px;
`;

const SkeletonButton = styled.div`
  width: ${(props) => props.width || "120px"};
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${skeletonAnimation} 1.5s infinite;
  border-radius: 5px;
  margin-top: 10px;
`;

const Line = styled.div`
  height: 22px;
`;

const SkeletonScreen = () => (
  <SkeletonWrapper>
    <SkeletonInput />
    <SkeletonButton />
    <SkeletonButton width="70px" />
    <SkeletonButton width="97px" />
    <Line />
    <SkeletonButton width="170px" />
    <SkeletonInput />
    <SkeletonInput />
    <SkeletonButton width="260px" />
    <Line />
    <SkeletonButton width="300px" />
    <SkeletonInput />
    <SkeletonInput />
    <Line />
    <SkeletonButton width="197px" />
    <SkeletonInput />
    <SkeletonInput />
    <Line />
    <SkeletonButton width="197px" />
    <SkeletonInput />
    <SkeletonInput />
  </SkeletonWrapper>
);

export default SkeletonScreen;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/skeletonScreen.js